import {Component} from "react";

export class SellToWebTableFooterComponent extends Component {
    render() {
        return this.props.children;
    }
}